
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/utils/analytics";

const BlogBackButton = () => {
  return (
    <div className="mb-8 max-w-4xl mx-auto">
      <Button 
        variant="ghost" 
        asChild 
        className="text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300 -ml-4"
        onClick={() => trackEvent('Blog', 'NavigationClick', 'Direction: Back to Blog')}
      >
        <Link to="/blog">
          <ArrowLeft className="mr-2" size={18} />
          Voltar para o Blog
        </Link>
      </Button>
    </div>
  );
};

export default BlogBackButton;
